export default __webpack_public_path__ + "static/media/ml-engineer.b473e23d.gif";